import React from 'react'
const Header = () => {
    return <h1>PokeKoi</h1>
}

export { Header }